/**
 * BOL v3（BOL Of Loading）基础样式
 */
export const BOL3_STYLES = `
.bol3-doc{background-color:#ffffff;max-width:570pt;margin:0 auto;padding:0 6px;color:#14142b;font-family:Arial,'Microsoft Yahei',sans-serif;font-size:12px;line-height:1.35;}
.bol3-doc table{border-collapse:collapse;border-spacing:0;width:100%;}
.bol3-block-table{table-layout:fixed;}
.bol3-block-table td{box-sizing:border-box;border:1px solid #14142b;}
.bol3-mono{font-variant-numeric:tabular-nums;}

/* Header */
.bol3-header{display:flex;align-items:flex-end;justify-content:space-between;padding-bottom:1px;}
.bol3-title{font-size:26px;font-weight:700;letter-spacing:-0.01em;margin-top:2px;}
.bol3-logo{height:31px;width:160px;background-repeat:no-repeat;background-position:center;background-size:contain;}

/* Date/Route + BOL barcode */
.bol3-meta-table td{border-bottom:none;}
.bol3-meta-left{padding:8px 6px;vertical-align:middle;}
.bol3-meta-right{padding:2px 6px;vertical-align:middle;text-align:center;}
.bol3-kv{display:flex;gap:8px;align-items:baseline;}
.bol3-kv+.bol3-kv{margin-top:6px;}
.bol3-kv .bol3-k{font-weight:600;font-size:12px;min-width:78px;flex-shrink:0;}
.bol3-kv .bol3-v{font-weight:600;font-size:14px;letter-spacing:0.02em;word-break:break-word;}
.bol3-barcode{width:100%;height:48px;background-repeat:no-repeat;background-position:center;background-size:100% 100%;}
.bol3-bol-number{display:flex;gap:8px;align-items:baseline;justify-content:center;}
.bol3-bol-number .bol3-v{font-weight:600;letter-spacing:0.14em;font-size:12px;word-break:break-all;}
.bol3-bol-id{margin-top:1px;}
.bol3-bol-id .bol3-k{font-weight:600;font-size:13px;flex-shrink:0;}
.bol3-bol-id .bol3-v{font-size:13px;letter-spacing:0.08em;}

/* Ship info N columns */
.bol3-ship-table{margin-bottom:3px;}
.bol3-ship-cell{padding:1px 6px;overflow:hidden;vertical-align:top;}
.bol3-ship-label{font-size:10px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;margin-bottom:1px;}
.bol3-ship-stop{font-size:11px;font-weight:400;}
.bol3-ship-code{font-size:12px;font-weight:900;}
.bol3-ship-name{font-size:12px;}
.bol3-ship-address{line-height:1.3;word-break:break-word;}
.bol3-ship-contact{margin-top:2px;padding-top:2px;border-top:1px dashed #b9b9cc;word-break:break-word;}
.bol3-ship-contact .bol3-name{font-weight:600;}
.bol3-ship-contact .bol3-phone{font-size:11px;}

/* Section title */
.bol3-section-title{font-size:12px;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;color:#14142b;margin-bottom:2px;margin-top:3px;}

/* 通用表格：fixed 布局 + 表头百分比列宽（取自原型实测渲染值），列宽不随内容漂移 */
.bol3-table{table-layout:fixed;}
.bol3-table th,.bol3-table td{box-sizing:border-box;border:1px solid #14142b;}
.bol3-table th{padding:2px 6px;font-size:10px;font-weight:700;letter-spacing:0.05em;text-transform:uppercase;color:#ffffff;background:#14142b;text-align:left;white-space:nowrap;}
.bol3-table th.bol3-center{text-align:center;}
.bol3-table td{padding:2px 6px;font-size:9px;word-break:break-word;}
.bol3-table td.bol3-center{text-align:center;}
.bol3-table td.bol3-middle{vertical-align:middle;}

/* Driver & Carrier */
.bol3-carrier-table td{padding:1px 6px;font-size:12px;font-weight:500;height:19px;word-break:break-word;}

/* Seal + Remark */
.bol3-seal-table{margin-bottom:3px;}
.bol3-seal-left{vertical-align:middle;}
.bol3-seal-row{padding:1px 6px;display:flex;gap:10px;align-items:baseline;}
.bol3-seal-row .bol3-k{font-weight:600;flex-shrink:0;}
.bol3-seal-row .bol3-v{font-weight:600;}
.bol3-remark-cell{padding:3px 6px;vertical-align:top;}
.bol3-remark-content{display:block;min-height:16px;word-break:break-word;white-space:pre-wrap;}

/* Loading information */
.bol3-loading-table{margin-bottom:3px;}
.bol3-loading-table td{padding:1px 6px;font-size:10px;line-height:12px;}
.bol3-loading-table td.bol3-dest{font-weight:600;vertical-align:middle;text-align:center;height:12px;}
/* 空单元格撑出与数据行等高的行盒（补出的空行不显示 ID，仍需保持行高） */
.bol3-loading-table td:not(.bol3-total-cell)::after{content:"";display:inline-block;}
.bol3-loading-table td.bol3-total-cell{padding:3px 14px;background:#ffffff;line-height:1.35;}
.bol3-total-inner{display:flex;justify-content:space-between;align-items:center;}
.bol3-total-label{font-weight:700;text-transform:uppercase;font-size:10px;letter-spacing:0.05em;}
.bol3-total-value{font-weight:600;font-size:14px;}

/* Signatures */
.bol3-sig-table td{padding:2px 6px;font-size:12px;}
/* Static ETA 单行展示（含时区时不换行） */
.bol3-sig-table td.bol3-eta{white-space:nowrap;font-size:11px;}
.bol3-sig-table td.bol3-loc{font-weight:700;}
.bol3-sig-table td.bol3-sig{font-style:italic;font-size:15px;}

/* 分页符 */
.bol3-page-break{page-break-after:always;}
`;
